var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 229,
  height: 28,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#logo-large_svg__a)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.197 27.832c5.129-6.16 15.106-13.778 29.717-14.493h.046C20.044 13.23 5.214 22.44 0 27.832z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.118 27.832c2.614-4.632 9.34-13.965 18.842-14.496-13.179.646-23.282 7.628-28.658 14.496z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC3C3C",
  d: "m11.396 19.344.544-.925 5.598-9.517 3.662 6.223.182.307a64.177 64.177 0 0 1 12.97-2.425c-2.548-.073-5.825.111-8.83.72l-.316-.539L17.539.168 9.4 13.998 4.402 22.49l-.988 1.68c2.452-1.826 5.146-3.418 7.874-4.776.037-.017.07-.036.108-.053M26.03 23.336l2.645 4.496h5.14l-4.778-8.12c2.383-2.467 5.242-4.523 8.545-5.498-3.357.751-6.344 2.606-8.893 4.903a32 32 0 0 0-2.133 2.124q-.539.59-1.05 1.204l.17.288.353.6z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo-large_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m167.711 9.853-7.658 13.059h-5.919l10.323-18.133h6.561l10.349 18.133h-5.946z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC3C3C",
  d: "M170.503 18.588h-5.85v4.298h5.85z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m99.695 9.853-7.662 13.059h-5.92L96.44 4.779h6.557l10.349 18.133h-5.945z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC3C3C",
  d: "M102.486 18.588h-5.849v4.298h5.849z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M208.687 9.386V5.088h20.309v4.298zm5.578 13.836h-5.578V12.104h20.309v3.932h-14.464v2.84h14.464v4.32zM65.25 9.36H51.454v3.128H64.45v4.233H51.454v5.877h-5.347V5.088H65.25V9.36M72.755 18.365h11.668v4.233H67.399V5.088h5.356zM122.874 22.598h-5.347V9.382h-7.335V5.088h20.012v4.294h-7.335v13.216zM141.431 18.365h11.668v4.233h-17.024V5.088h5.356zM206.005 22.598h-7.842L187.649 9.862v12.736h-5.347V5.088h7.924l10.44 12.841V5.09H206v17.509z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-large_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .168h39.96v27.664H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-large_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M46.107 4.779H229v18.443H46.107z"
})))));
export default SvgLogoLarge;